import React, { memo, useCallback, useRef, useState, useEffect } from 'react';
import { PopAlert } from 'appkit-react';
import { connect, useDispatch } from 'react-redux';
import action from '@flux/action';
import { useHistory, Prompt } from 'react-router-dom';
import Client from './client';
import { Tabs, Modal, Divider, Checkbox } from 'antd';
import alert from '@components/alert';

import ProjectBasePage from './createProject';
import PWCTeams from './pwcTeams';
import Module from './projectModuleSetting';

// import '@style/modules/project/projectsSetting.scss';
import '../../../styles/modules/project/projectSettingModule.scss';
import useProjectId from '@hooks/useProjectId';
import { setSessionStorage, getSessionStorage } from '@utils/windowUtil';
import { setURLSearchParam } from '@utils/history';
import UserGroups from '@modules/projects/projectSetting/groups';
import EventListener, { eventNames } from '@utils/eventListener';
import { SaveAndCancelBtns } from '@components/actionButtonsGroup';
import { oldProjectRoleNames, projectRole, USER_ROLE_MODEL } from '@model';
import PendoIO from '@utils/pendo';
import {
  projectHomeAddModalConfig,
  projectModuleAddModalConfig,
} from '@model/settings/addModalConfig';
import ChatAiSettingsTab from '../../../aiChat/settings/ChatAiSettingsTab';
import {
  CHAT_AI_ENABLE_CHAT_SERVER_CHANGED,
  extractEnableChatMapFromModuleInfo,
} from '../../../aiChat/api/gatewayProjectEnableChat';
import { validateSubmoduleName } from '@modules/systemSetting/systemModule/helper';

const { TabPane } = Tabs;
const { confirm } = Modal;
function ProjectSetting({
  memberData,
  operatorName,
  getProjectSetting,
  saveTeamsNames,
  changeTeamsDetail,
  settingData,
  settingProjectData,
  saveProjectSettings,
  changeTeamsNames,
  changeMembersData,
  // saveUserPermission,
  clearTeamsData,
  singleCompanyInstance,
  projectId,
  userId,
  userName,
  userRole,
  clearCompanyName,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const id = useProjectId();
  const isAdmin = userRole === USER_ROLE_MODEL.ADMIN;

  const [teamFormData, setTeamFormData] = useState(null);
  const [clientFormData, setClientFormData] = useState(null);
  const [moduleFormData, setModuleFormData] = useState(null);
  const [groupData, setGroupData] = useState(null);
  // member 和 client数据变化的标志位
  // 可能值有三个: 1. null:没有变化  2.edit:编辑过【remove算编辑过】  3.add:新增过
  const [memberOrClientChange, setMemberOrClientChange] = useState(null); // null || edit || add
  const [m365Data, setM365Data] = useState({});
  const [changeCompanyLoading, setChangeCompanyLoading] = useState(false);

  const projectRef = useRef(null);
  const teamRef = useRef(null);
  const moduleRef = useRef(null);
  const clientRef = useRef(null);
  const groupRef = useRef(null);
  const saveRef = useRef(null);
  const getModuleFormForChatAi = useCallback(
    () => moduleRef.current?.getModuleForm?.(),
    [],
  );
  const [tabKey, setTabKey] = useState(
    new URLSearchParams(window.location.search).get('tab') || 'projectTab',
  );
  // 如果是点击页面的save或者cancel离开页面的话该值为false
  // 是否阻止离开当前页面
  const promptShouldOpen = useRef(true);

  const handleBack = () => {
    if (
      ['add', 'edit'].includes(memberOrClientChange) ||
      teamRef.current?.getTeamFromRef?.current?.getEditInfo() ||
      clientRef?.current?.getEditInfo()
    ) {
      alert.confirm({
        content: 'Are you sure you want to leave without saving your changes?',
        okText: 'Yes, leave without saving',
        cancelText: 'No',
        onOk: (e) => {
          promptShouldOpen.current = false;
          clearCompanyName();
          //e.triggerCancel 为点击'x' btn 标识
          //当点击cancel时  e 为 close function
          if (!e.triggerCancel) {
            if (history.location.state?.from) {
              history.push(history.location.state?.from);
            } else {
              history.push(`/project-detail/${id}`);
            }
            e(); //手动调用close function
          }
        },
        onCancel: (e) => e(),
      });
      return;
    }

    clearCompanyName();
    if (history.location.state?.from) {
      history.push(history.location.state?.from);
    } else {
      history.push(`/project-detail/${id}`);
    }
  };

  useEffect(() => {
    setURLSearchParam(history, { tab: tabKey });
  }, [tabKey]);

  const fetchData = async (id) => {
    if (!id) {
      return;
    }
    const data = await getProjectSetting(id);
    if (data) {
      settingProjectData(data.projectInfo);
      setTeamFormData(data.teamInfo);
      setClientFormData(data.clientInfo);
      setGroupData(data.groups);
      setModuleFormData({ customizeModule: data.moduleInfo });
      console.log(data);
      setM365Data(data.M365);
      // saveUserPermission(data.clientInfo.clientPermissionModules);
      setSessionStorage(
        'project_setting_buyerCompany_name',
        data.projectInfo?.buyerCompanyInfo?.name || '',
      );
      setSessionStorage(
        'project_setting_targetCompany_name',
        data.projectInfo?.targetCompanyInfo?.name || '',
      );
    }
    setMemberOrClientChange(null);
  };
  useEffect(() => {
    fetchData(id);
    return () => {
      settingProjectData({ clear: true, currentNum: 1 });
      saveTeamsNames({ data: [], memberData: [] });
      changeTeamsDetail(null);
      changeTeamsNames({ data: [] });
      clearTeamsData();
    };
  }, [id]);

  const scrollYSync = () => {
    setTimeout(() => {
      window.scrollBy({ top: -64 });
    });
  };

  const pendoCommon = {
    project_id: projectId,
    uid: userId,
    user_name: userName,
  };

  useEffect(() => {
    PendoIO.track('Project Setting - Enter', pendoCommon);
  }, []);

  const handleTrack = (prevData, currData) => {
    prevData = prevData.map((value) => ({
      dataSourceLink: value.dataSourceLink,
      icon: value.icon,
      id: value.id,
      iframe: value.iframe,
      link: value.link,
      module: value.module,
      type: value.type,
    }));

    currData = currData.map((value) => ({
      dataSourceLink: value.dataSourceLink,
      icon: value.icon,
      id: value.id,
      iframe: value.iframe,
      link: value.link,
      module: value.module,
      type: value.type,
    }));

    const prev = prevData.map((i) => JSON.stringify(i));
    const curr = currData.map((i) => JSON.stringify(i));

    let addData = curr
      .map((value, index) => {
        if (!prev.includes(value)) {
          return currData[index];
        }
      })
      .filter(Boolean);

    let deleteData = prev
      .map((value, index) => {
        if (!curr.includes(value)) {
          return prevData[index];
        }
      })
      .filter(Boolean);

    let editData = [];
    for (let i = 0; i < addData.length; i++) {
      for (let j = 0; j < deleteData.length; j++) {
        if (!addData[i].id) {
          continue;
        }
        if (addData[i].id === deleteData[j].id) {
          editData.push(addData[i]);
        }
      }
    }
    editData = [...new Set(editData)];
    const edita = editData.map((value) => value.id);
    addData = addData.filter((value) => {
      if (!value.id) {
        return true;
      }
      return !edita.includes(value.id);
    });
    deleteData = deleteData.filter((value) => !edita.includes(value.id));

    for (const i in addData) {
      PendoIO.track('Project Modules - Add Module', {
        module_name: addData[i].module,
        dataSourceLink: addData[i].dataSourceLink,
        link: addData[i].link,
        ...pendoCommon,
      });
    }
    for (const i in deleteData) {
      PendoIO.track('Project Modules - Delete Module', {
        module_name: deleteData[i].module,
        ...pendoCommon,
      });
    }
    for (const i in editData) {
      PendoIO.track('Project Modules - Edit Module', {
        module_name: editData[i].module,
        dataSourceLink: editData[i].dataSourceLink,
        link: editData[i].link,
        ...pendoCommon,
      });
    }
    PendoIO.track('Project Modules - Save', pendoCommon);
  };

  const handleSaveWithConfirm = async () => {
    if (
      teamRef.current.getTeamFromRef.current.getEditInfo() ||
      clientRef.current.getEditInfo()
    ) {
      alert.confirm({
        content: 'Do you want to save the rows in editing?',
        okText: 'Yes, save all changes',
        cancelText: 'No',
        onOk: handleSave,
        onCancel: async (e) => {
          //e.triggerCancel 为点击'x' btn 标识
          //当点击cancel时  e 为 close function
          if (!e.triggerCancel) {
            // 啥也不做，停留在这个页面【强制用户必须操作完pwc team和client team 俩个tab下的操作】
            // await teamRef?.current?.getTeamFromRef?.current?.cancelEditing?.();
            // await clientRef?.current?.cancelEditing?.();
            // // 执行save的逻辑
            // saveRef.current();
            // 执行关闭操作
            e();
          }
        },
      });
    } else {
      handleSave();
    }
  };

  const handleSave = async () => {
    let clientSetting, moduleSetting;
    // 这是project的模块逻辑 开始
    try {
      const refs = projectRef.current;
      await refs?.getProjectForm?.validateFields();
      if (refs?.subOneRef) {
        await refs.subOneRef.subOneForm?.validateFields();
      }
      if (refs?.subTwoRef) {
        await refs.subTwoRef.subTwoForm?.validateFields();
      }
    } catch (e) {
      const errArr = e.errorFields && e.errorFields[0].errors;
      const errMSG = (Array.isArray(errArr) && errArr[0]) || '';
      alert.warning(errMSG);
      setTabKey('projectTab');
      return;
    }
    // 这是project的模块逻辑 结束

    try {
      clientSetting =
        (await clientRef.current?.getClientForm().validateFields()) ||
        clientFormData;
      if (clientSetting) {
        clientSetting.clientList = (clientSetting?.clientList || []).filter(
          (item) => {
            delete item.fieldKey;
            delete item.index;
            delete item.key;
            delete item.isNew;
            return item.email?.trim?.();
          },
        );
      }
    } catch (e) {
      const error =
        e.errorFields && e.errorFields[0] && e.errorFields[0].errors[0];

      // Modal.warning({ content: error });
      alert.warning(error);

      setTabKey('clientTab');
      return;
    }
    const moduleForm = moduleRef.current?.getModuleForm();
    try {
      moduleSetting = (await moduleForm.validateFields()) || moduleFormData;
      if (Array.isArray(moduleSetting?.customizeModule)) {
        moduleSetting.customizeModule.forEach((i) => {
          if (!i.groupPermissions) {
            i.groupPermissions = [];
          }
        });
      }
    } catch (e) {
      const error =
        e.errorFields && e.errorFields[0] && e.errorFields[0].errors[0];

      if (tabKey !== 'modules') {
        setTabKey('modules');
      }
      // Modal.warning({ content: error });
      alert.warning(error);
      moduleForm.scrollToField(e.errorFields[0].name, { inline: 'start' });
      scrollYSync();

      return;
    }

    if (!validateSubmoduleName(moduleSetting?.customizeModule)) {
      return;
    }

    const id = getSessionStorage('currentId');

    const groupDataValid = groupRef.current?.validate();
    if (!groupDataValid) {
      return;
    }
    const groupFormData = groupRef.current?.getData() || groupData;
    groupFormData.forEach((i) => {
      i.groupInfo.projectId = id;
    });
    const newPermissionsValue =
      teamRef.current?.getTeamForm()?.getFieldsValue()?.teamMember || [];
    const members = [...new Set(memberData)]
      .filter((member) => member?.guid)
      .map((item) => ({
        ...item,
        permission:
          newPermissionsValue.find((ite) => ite.email === item.email)
            ?.permission || item.permission,
      }));
    try {
      await teamRef.current.getTeamFormValidata(members);
    } catch (e) {
      setTabKey('teamTab');
      return;
    }
    for (const i in members) {
      switch (members[i].role_name) {
        case oldProjectRoleNames[0]:
          members[i].isManager = false;
          members[i].isLead = true;
          break;
        case oldProjectRoleNames[1]:
          members[i].isManager = true;
          members[i].isLead = false;
          break;
        default:
          members[i].isManager = false;
          members[i].isLead = false;
      }
    }

    if (!settingData.targetLabel) {
      settingData.targetLabel =
        settingData.intanceType !== 'Divestiture' ? 'Target' : 'Buyer';
    }
    if (!settingData.buyerLabel) {
      settingData.buyerLabel =
        settingData.instanceType !== 'Divestiture' ? 'Buyer' : 'RemainCo';
    }

    delete settingData.buyerCompanyInfo.duns;

    settingData?.isSingleCompany && delete settingData.targetCompanyInfo;
    const result = {
      teamSetting: { members, operatorName },
      projectSetting: settingData,
      clientSetting,
      moduleSetting: moduleSetting.customizeModule,
      groupSetting: groupFormData,
    };

    async function handleSubmit() {
      result.isKeepAnalysis = false;
      result.isKeepValueDirver = false;
      setChangeCompanyLoading(true);
      delete result.projectSetting.currentNum;
      console.log('最终吴迪处理完提交的数据：', result);

      const { success, hasAuth } = await saveProjectSettings(result);
      if (success) {
        if (Array.isArray(result.moduleSetting) && result.moduleSetting.length) {
          window.dispatchEvent(
            new CustomEvent(CHAT_AI_ENABLE_CHAT_SERVER_CHANGED, {
              detail: {
                projectId: id,
                moduleEnableChatMap: extractEnableChatMapFromModuleInfo(
                  result.moduleSetting,
                ),
              },
            }),
          );
        }
        if (
          !window.location.href.includes(
            result?.moduleSetting[0]?.projectId?.toUpperCase(),
          )
        ) {
          return;
        }
        handleTrack(
          moduleFormData.customizeModule,
          moduleForm.getFieldsValue().customizeModule,
        );
        const projectName = result.projectSetting.projectName;
        setSessionStorage('projectName', projectName);
        dispatch(action.matchBreadCrumb(projectName));
        dispatch(action.getProjectInfo(id));
        dispatch(action.getAccessibleModules(id));
        dispatch(action.saveProjectDetail({ currentTab: null }));
        hasAuth && fetchData();
        PopAlert({
          className: 'success-message-popover',
          oneLineDisplay: true,
          duration: 2000,
          status: 'success',
          message: 'SAVED SUCCESSFULLY',
        });

        promptShouldOpen.current = false;
        if (!hasAuth) {
          history.push(`/project-detail/${id}`);
        } else {
          history.goBack();
        }
      }
      setChangeCompanyLoading(false);
    }
    console.log(
      '提交的时候初始的buyer：',
      getSessionStorage('project_setting_buyerCompany_name'),
    );
    console.log(
      '提交的时候初始的target：',
      getSessionStorage('project_setting_targetCompany_name'),
    );
    console.log('提交的数据：', settingData);
    if (
      (settingData.buyerCompanyInfo.name || '') !=
        getSessionStorage('project_setting_buyerCompany_name') ||
      (settingData.targetCompanyInfo.name || '') !=
        getSessionStorage('project_setting_targetCompany_name')
    ) {
      result.isChangeCompany = true;
      confirm({
        icon: null,
        title: 'Change Buyer / Seller',
        wrapClassName: 'change_company_modal',
        content: (
          <>
            All manually edited or uploaded data will be cleared and updated
            with new data. Would you like to cancel and check Side-by-Side
            Analysis and Value Drivers before changing companies?
            {/* Please note changing companies will update the SxS Analysis module
            and Value Drivers (IMO/SMO Launch).with new data. Please indicate
            below if you wish to keep changes that may have been made (e.g.,
            custom fields, overridden values):
            <Divider />
            <Checkbox
              onChange={(e) => {
                result.isKeepAnalysis = e.target.checked;
              }}
            >
              SxS Analysis
            </Checkbox>
            <Checkbox
              onChange={(e) => {
                result.isKeepValueDirver = e.target.checked;
              }}
            >
              Value Drivers
            </Checkbox> */}
          </>
        ),
        confirmLoading: changeCompanyLoading,
        cancelText: 'Yes, cancel',
        okText: 'No, clear and update with new data',
        cancelButtonProps: {
          disabled: changeCompanyLoading,
        },
        onOk: handleSubmit,
      });
    } else {
      handleSubmit();
    }
  };
  saveRef.current = handleSave;

  const handleTabClick = (key) => {
    if (tabKey === 'groups' && groupRef.current) {
      const groupDataValid = groupRef.current.validate();
      if (!groupDataValid) {
        return;
      }
    }
    setTabKey(key);
  };

  async function getAllUser() {
    const pwcTeams = [...new Set(memberData)].filter((member) => member?.email);
    let clients = [];
    try {
      clients = (
        (await clientRef.current?.getClientForm().validateFields()) ||
        clientFormData
      )?.clientList
        ?.filter((item) => item.email.trim())
        .map((i) => ({ ...i, isClient: true }));
    } catch (e) {
      console.log(e);
    }
    return [...pwcTeams, ...clients];
  }
  const changeUserRole = (isAdmin, user) => {
    const teamForm = teamRef.current?.getTeamForm();
    if (teamForm) {
      const teamValues = teamForm.getFieldsValue();
      console.log('teamValues: ', teamValues);
      teamValues.teamMember.forEach((item) => {
        if (item.email === user.email) {
          item.permission = isAdmin
            ? projectRole.Contributor
            : projectRole['View-Only'];
        }
      });
      teamForm.setFieldsValue(teamValues);
      changeMembersData({ memberData: teamValues.teamMember });
    }
  };
  const getGroupData = () => {
    if (groupRef.current?.getData) {
      return groupRef.current?.getData();
    }
    return groupData;
  };
  //callback to change group members
  const groupManip = {
    updateTeamMember: (data) => {
      eventListener.current.emit(eventNames.userChange, 'update', data);
    },
    updateClient: (data) => {
      eventListener.current.emit(eventNames.userChange, 'update', {
        ...data,
        isClient: true,
      });
    },
    deleteTeamMember: (data) => {
      eventListener.current.emit(eventNames.userChange, 'delete', data);
    },
    deleteClient: (data) => {
      eventListener.current.emit(eventNames.userChange, 'delete', {
        ...data,
        isClient: true,
      });
    },
  };

  const eventListener = useRef(new EventListener());

  const handlePrompt = (location) => {
    if (
      !promptShouldOpen.current ||
      location.pathname.startsWith('/projects/setting')
    ) {
      return true;
    }

    // 如果不是点击保存或者cancel离开页面的话才走这个判断
    if (
      ['add', 'edit'].includes(memberOrClientChange) ||
      teamRef.current?.getTeamFromRef?.current?.getEditInfo?.() ||
      clientRef.current?.getEditInfo?.()
    ) {
      alert.confirm({
        onOk: () => {
          promptShouldOpen.current = false;
          setTimeout(() => {
            history.push(location.pathname + location.search);
          }, 0);
        },
        onCancel: () => false,
        okText: 'Yes, leave without saving',
        content: 'Are you sure you want to leave without saving your changes?',
        cancelText: 'No',
        async: true,
        noCloseIcon: true,
        maskClosable: false,
      });
    } else {
      return true;
    }
    return false;
  };

  return (
    <div className="projects-setting-page-wrapper">
      <Prompt message={handlePrompt} />
      <div className="content-container">
        <span className="dd-back-btn" onClick={handleBack}>
          <span className="appkiticon icon-left-chevron-fill a-font-12" /> Back
        </span>
        <h1 className="project-form-title">
          Settings
          <SaveAndCancelBtns
            handleBack={handleBack}
            handleSave={handleSaveWithConfirm}
          />
        </h1>

        {/* </Affix> */}
        <div
          className="integration-manage-tab-wrapper"
          id="project-settings-tab-pane"
        >
          <Tabs type="card" activeKey={tabKey} onTabClick={handleTabClick}>
            <TabPane tab="Project" key="projectTab">
              {(settingData.projectName || settingData.buyerCraftId) && (
                <ProjectBasePage cRef={projectRef} />
              )}
            </TabPane>
            <TabPane tab="PwC Team" key="teamTab" forceRender={true}>
              <PWCTeams
                cRef={teamRef}
                teamFormData={teamFormData}
                getGroupData={getGroupData}
                groupManip={groupManip}
                setMemberOrClientChange={setMemberOrClientChange}
              />
            </TabPane>
            <TabPane tab="Client Team" key="clientTab" forceRender={true}>
              <Client
                cRef={clientRef}
                clientFormData={clientFormData}
                getGroupData={getGroupData}
                groupManip={groupManip}
                singleCompanyInstance={singleCompanyInstance}
                setMemberOrClientChange={setMemberOrClientChange}
                projectId={projectId}
                projectName={settingData?.projectName ?? ''}
              />
            </TabPane>
            <TabPane tab="Groups" key="groups" forceRender={true}>
              <UserGroups
                initialData={groupData}
                getAllUser={getAllUser}
                ref={groupRef}
                eventListener={eventListener.current}
                changeUserRole={changeUserRole}
              />
            </TabPane>
            <TabPane tab="Modules" key="modules" forceRender={true}>
              <Module
                cRef={moduleRef}
                moduleFormData={moduleFormData}
                tabKey={tabKey}
                hideHomeSections
                changeTab={handleTabClick}
                getGroupData={getGroupData}
                eventListener={eventListener.current}
                sectionAddModuleConfig={projectHomeAddModalConfig}
                addModuleConfig={projectModuleAddModalConfig}
              />
            </TabPane>
            <TabPane tab="Chat AI" key="chatAi" forceRender={true}>
              <ChatAiSettingsTab
                customizeModule={moduleFormData?.customizeModule}
                getModuleForm={getModuleFormForChatAi}
                operatorName={operatorName}
                onSaved={() => fetchData(id)}
              />
            </TabPane>
            {/* {isAdmin && <TabPane tab="M365" key="m365" forceRender={true}>
              <M365 data={m365Data} />
            </TabPane>} */}
          </Tabs>

          {/* <Modal
            icon={null}
            title="Change Buyer / Seller"
            wrapClassName="change_company_modal"
            visible={isModalVisible}
            onOk={handleSubmit}
            okText="save"
            confirmLoading={changeCompanyLoading}
            cancelButtonProps={{
              disabled: changeCompanyLoading, // This should now work
            }}
          >
            <>
              Please note changing companies will update the SxS Analysis module
              and Value Drivers (IMO/SMO Launch).with new data. Please indicate
              below if you wish to keep changes that may have been made (e.g.,
              custom fields, overridden values):
              <Divider />
              <Checkbox
                onChange={(e) => {
                  result.isKeepAnalysis = e.target.checked;
                }}
              >
                SxS Analysis
              </Checkbox>
              <Checkbox
                onChange={(e) => {
                  result.isKeepValueDirver = e.target.checked;
                }}
              >
                Value Drivers
              </Checkbox>
            </>
          </Modal> */}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ projects, login, common }) => ({
  memberData: projects.memberData,
  operatorName: `${login.userInfo.given_name} ${login.userInfo.family_name}`,
  settingData: projects.settingData,
  singleCompanyInstance: common.projectCompanyInfo.singleCompanyInstance,
  projectId: common.currentId,
  userId: login.userInfo.guid,
  userName: `${login.userInfo.given_name} ${login.userInfo.given_name}`,
  userRole: login.userInfo.role,
});

const mapDispatchToProps = (dispatch) => ({
  changeTeamsDetail(data) {
    dispatch(action.changeTeamsDetail(data));
  },
  clearTeamsData() {
    dispatch(action.clearTeamsData());
  },
  changeTeamsNames(data) {
    dispatch(action.changeTeamsNames(data));
  },
  saveTeamsNames(data) {
    dispatch(action.saveTeamsNames(data));
  },
  settingProjectData(word, type) {
    dispatch(action.settingProjectData(word, type));
  },
  changeMembersData(data) {
    dispatch(action.changeMembersData(data));
  },
  // saveUserPermission(permission = []) {
  //   dispatch(action.saveUserPermission(permission));
  // },
  async saveProjectSettings(data) {
    return await dispatch(action.saveProjectSettings(data));
  },
  async getProjectSetting(data) {
    return await dispatch(action.getProjectSetting(data));
  },
  clearCompanyName() {
    dispatch(action.clearCompanyName());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(ProjectSetting));
